import { NAVEGACAO_PORTAL, NAVEGACAO_LEGADO, NAVEGACAO_JANUS } from "@/portal/constantes";
import { Getters } from "../types";
import router from '@/router';

const buildUrlFromState = (st) => {
    const url = new URL(`${window.location.origin}/${st.contexto}/`);
    if(st.publico){
        url.pathname += st.caminho;
        url.search += st.parametros;
    } else {
        url.pathname += 'autenticar';
        if(st.perfilAtual) {
           url.searchParams.append('numnivseg', st.perfilAtual.numero );
        }
        url.searchParams.append('url_redirect', `${escape(st.caminho)}?${st.parametros}`);
    }
    return url;
}

const limparFragmento = (fragmento) => {
    let frag = fragmento.replace(/ref-portal=.+&?/, '')
                .replace(/&$/, '');
    if(frag.endsWith('?')) {
        frag = frag.substring(0, frag.length - 1);
    }
    return frag;
}

// Estado inicial
const state = {
    caminho: '',
    contexto: '',
    menu: null,
    perfilAtual: null,
    perfis: [],
    parametros: '',
    publico: true,
    refPortal: window.location.origin,
    sistema: null,
    tipoNavegacao: null,
    urlLegado: ''
}

// getters
const getters = {
    area: (state) => state.sistema ? state.sistema.nomeArea : '',
    outrosPerfis: (state) => state.perfis ? state.perfis.filter(p => p.numero !== state.perfilAtual.numero) : [],
    perfilAtual: (state) => state.perfilAtual,
    publico: (state) => state.publico,
    tipoNavegacao: (state) => state.tipoNavegacao,
    urlLegado: (state) => state.urlLegado
}

// actions
const actions = {
    navegarPeloMenu: (context, { menu }) => {
        let sistema = context.rootGetters['nav/sistemaPorArea'](menu.area.codigo),
            contexto = (context.rootGetters[Getters.AREAS.AREA_POR_CODIGO](menu.area.codigo) || sistema).contexto,
            caminho = menu.objetoWeb;

        context.commit('navegacaoPortal');
        context.commit('caminho', caminho);
        context.commit('contexto', contexto);
        context.commit('sistema', sistema);
        context.commit('menu', menu);
        context.commit('perfis', menu.perfis);
        context.commit('parametros', menu.parametros);
        context.commit('urlLegado');
    },

    atualizarNavegacaoLegada: (context, { urlLegado, contexto }) => {
        let frag = limparFragmento(urlLegado),
            caminho = frag.split('?')[0],
            parametros = frag.split('?')[1] || '',
            publico = context.state.publico,
            matchCodigoMenu = parametros.match(/codmnu=(\w+)&?/),
            codigoMenu = matchCodigoMenu ? matchCodigoMenu[1] : null,
            sistema = context.rootGetters['nav/sistemaPorContexto'](contexto),
            menu = context.rootGetters['nav/menuPorCodigo'](codigoMenu);

        context.commit('navegacaoLegado');
        context.commit('caminho', caminho);
        context.commit('contexto', contexto);
        context.commit('sistema', sistema);
        context.commit('menu', menu);
        context.commit('parametros', parametros);
        if(!menu && !publico){
            return context.dispatch('nav/carregarObjetoweb', { caminho: caminho, sistema: sistema.nomeSistema }, { root: true })
                   .then(objetoweb => {
                        context.commit('perfis', objetoweb ? objetoweb.perfis : []);
                        return `/${context.state.publico ? 'publico' : 'servicos'}/${sistema.codigoArea}/${unescape(frag)}`;
                   });
        } else {
            context.commit('perfis', publico ? [] : menu.perfis);
            return `/${context.state.publico ? 'publico' : 'servicos'}/${sistema.codigoArea}/${unescape(frag)}`;
        }
    },

    atualizarNavegacaoJanus: (context) => {
        context.commit('urlLegado');
        context.commit('navegado');
    },

    navegarPeloPortal: (context, { urlPortal }) => {
        let url = urlPortal.replace('/servicos/', '').replace('/publico/', ''),
            indiceBarra = url.indexOf('/'),
            codigoArea = url.substring(0, indiceBarra),
            fragmento = url.substring(indiceBarra + 1),
            caminho = fragmento.split('?')[0],
            publico = urlPortal.indexOf('/publico/') !== -1,
            parametros = fragmento.split('?')[1] || '',
            matchCodigoMenu = parametros.match(/codmnu=(\w+)&?/),
            codigoMenu = matchCodigoMenu ? matchCodigoMenu[1] : null,
            autenticado = context.rootGetters['auth/autenticado'];

        let menu = context.rootGetters['nav/menuPorCodigo'](codigoMenu),
            sistema = context.rootGetters['nav/sistemaPorArea'](codigoArea),
            contexto = (context.rootGetters[Getters.AREAS.AREA_POR_CODIGO](codigoArea) || sistema).contexto;

        context.commit('navegacaoPortal');
        context.commit('caminho', caminho);
        context.commit('contexto', contexto);
        context.commit('sistema', sistema);
        context.commit('menu', menu);
        context.commit('parametros', parametros);

        if(!menu && !publico){
            return context.dispatch('nav/carregarObjetoweb', { caminho: caminho, sistema: sistema.nomeSistema }, { root: true })
                   .then(objetoweb => {
                        context.commit('perfis', objetoweb ? objetoweb.perfis : []);
                        if(!autenticado && !context.state.publico){
                            router.push({ name: 'home' });
                        }
                        context.commit('urlLegado');
                   });
        } else {
            context.commit('perfis', publico ? [] : menu.perfis);
            if(!autenticado && !context.state.publico){
                router.push({ name: 'home' });
            }
            context.commit('urlLegado');
        }
    },

    selecionarPerfil: (context, perfil) => {
        context.commit('navegacaoPortal');
        context.commit('perfilAtual', perfil);
        context.commit('urlLegado');
    }
}

// mutations
const mutations = {
    caminho: (state, caminho) => state.caminho = caminho,
    contexto: (state, contexto) => state.contexto = (contexto || '').trim(),
    menu: (state, menu) => state.menu = menu,
    navegado: state => state.tipoNavegacao = null,
    navegacaoLegado: state => state.tipoNavegacao = NAVEGACAO_LEGADO,
    navegacaoJanus: state => state.tipoNavegacao = NAVEGACAO_JANUS,
    navegacaoPortal: state => state.tipoNavegacao = NAVEGACAO_PORTAL,
    parametros: (state, parametros) => {
        state.parametros = parametros || '';
        if(state.menu && state.parametros.indexOf('codmnu') === -1){
            state.parametros += (state.parametros ? '&' : '') + `codmnu=${state.menu.codigo}`;
        }
        state.parametros += (state.parametros ? '&' : '') + `ref-portal=${escape(state.refPortal)}`;
    },
    perfis: (state, perfis) => {
        state.perfis = perfis;
        state.publico = !(perfis && perfis.length >= 1);
        state.perfilAtual = state.publico ? null : state.sistema.obterPerfilSelecionado(perfis);
    },
    perfilAtual: (state, perfil) => {
        state.sistema.selecionarPerfil(perfil);
        state.perfilAtual = perfil;
    },
    sistema: (state, sistema) => state.sistema = sistema,
    urlLegado: (state) => {
        const url = buildUrlFromState(state);
        if(state.urlLegado === url.toString()){
            url.searchParams.append('vportal', new Date().getTime());
        }
        state.urlLegado = url.toString();
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}